export class PatientRatioRecord {
    id: number;
    shiftBlockId: number;
    shiftRecordId?: number;
    workflowTimeFacility: string;
    ratioLabel: string;
    patientRatioId: number;
    amount: number;
    modifiedByUserName: string;
    modifiedDate: Date;
}